const E = "lineHeight", T = ["paragraph", "heading"];
export {
  E as LINE_HEIGHT_ATTRIBUTE,
  T as LINE_HEIGHT_TYPES
};
